import { connect } from 'react-redux'
import { setConfigurator } from '../../actions'
import Interior from './Interior'

const mapStateToProps = state => ({
  configurator: state.configurator
})

const mapDispatchToProps = {
  setConfigurator
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Interior)
